#import "../../../reactions/graphql/fragments/reaction-fragment.graphql"

fragment CommentFragment on Comment {
    id
    bodyHtml
    changeLogEntry {
        id
    }
    reactions {
        ...ReactionFragment
    }
    creatorUser {
        id
        name
        avatarUrl
        initials
        htmlUrl
    }
    createdTime
    isDeleteable
}
